import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { ContactEmail } from "./PolicyPage";

const policyGroups = [
  {
    title: "Shopping & orders",
    links: [
      ["Terms of Sale", "/terms-of-sale"],
      ["Payment & Billing", "/payment-policy"],
      ["Order & Cancellation", "/order-policy"],
      ["Shipping & Delivery", "/shipping"],
      ["Returns, Refunds & Exchanges", "/returns"],
      ["Product Warranty", "/warranty"],
      ["Subscriptions", "/subscriptions"],
      ["Promotions, Discounts & Gift Cards", "/promotions"],
    ],
  },
  {
    title: "Privacy, safety & access",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Cookie Policy", "/cookies"],
      ["Food Safety & Allergen Notice", "/food-safety"],
      ["Accessibility Statement", "/accessibility"],
      ["Responsible Disclosure", "/security"],
    ],
  },
  {
    title: "Website rules & legal",
    links: [
      ["Terms of Service", "/terms"],
      ["Acceptable Use", "/acceptable-use"],
      ["Intellectual Property", "/intellectual-property"],
      ["Website & Product Disclaimer", "/disclaimer"],
      ["Legal Notice", "/legal-notice"],
    ],
  },
];

function PolicyIndex() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <PolicyPage title="Policies" showUpdated={false}>
      <p>Find the terms, customer-care information, privacy notices, and safety guidance that apply when you visit or shop with camartzuno.</p>
      {policyGroups.map((group) => (
        <section key={group.title} aria-labelledby={group.title.replaceAll(" ", "-").toLowerCase()}>
          <h2 id={group.title.replaceAll(" ", "-").toLowerCase()}>{group.title}</h2>
          <ul>
            {group.links.map(([label, path]) => (
              <li key={path}><Link to={path} onClick={toTop}>{label}</Link></li>
            ))}
          </ul>
        </section>
      ))}
      <h2>Questions</h2>
      <p>If you are unsure which policy applies, email <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default PolicyIndex;
